/**
 * Vite build-time env access, isolated in its own module so the runtime
 * resolver (and its tests) never have to touch `import.meta`. Vite statically
 * replaces `import.meta.env` at build; tests mock this single function.
 */
export function readBuildEnv(key: string): string | undefined {
  const v = import.meta.env[key as keyof ImportMetaEnv];
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}
